import offside from 'offside-js';
import LazyLoad from 'vanilla-lazyload';
import { spotFavourites } from '../components/favourite';

export default {
  init() {  

    // Load favourite function
    spotFavourites();

    // Vanilla lazyload

    var lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy",
      // ... more custom settings?
    });

    $(document).on('facetwp-loaded', function() {
      var scrollTo = $('.welcome').offset().top - 200;
      $("html, body").animate({scrollTop: scrollTo }, 500);
      lazyLoadInstance.update();
    });

    // Vanilla offside.js
    if(document.getElementById('spot-offcanvas-menu')) {
      offside( '#spot-offcanvas-menu', {
        slidingElementsSelector:'#spot-main-content',
        buttonsSelector: '.spot-offcanvas-button',
        debug: true,
        slidingSide: 'right',
      });
    }

    $('a.scroll').click(function(event) {
      var headerheight = $('.spk-nav__wrapper').outerHeight(true);
      if ( location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&  location.hostname == this.hostname ) {

        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
              scrollTop: target.offset().top-headerheight,
            }, 600, function() {
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });
  
  $('.mobile-toggle-sidebar').on('click', function(el) {
		el.preventDefault();
		$(this).toggleClass('is-active');
		$('.sidebar--offcanvas').toggleClass('is-active');
	});
  
	$('[data-toggle="tooltip"]').tooltip();

  $('#searchwp_limit_to_magazine, #searchwp_limit_to_locations, #searchwp_limit_to_immo').prop('indeterminate', true)
	
  $('.gallery-slider').slick({
    dots: false,
    prevArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  prev"><i class="icon-arrow-left2"></i></button>',
    nextArrow: '<button type="button" class="slider-control slider-control--offset shadow-sm  next"><i class="icon-arrow-right2"></i></button>',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
  });

  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired

  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js